import { Grid } from "@mui/material";
import React from "react";
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { CountryEnum } from "src/common/enum";
import { PhoneInput, StateInput } from "src/components/input";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { MakerCreateComponent } from "./MakerComponent";
import Transformer from "src/common/Transformer";

export const MakerCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: [],
      update: {
        type: data.type.id,
        region: data.region.id
      },
    });
    return data;
  };

  return(  
  <Create component={MakerCreateComponent} transform={transform}>
    <SimpleForm>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} lg={6}>
          <TextInput source="name" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={6}>
          <TextInput source="website" />
        </Grid>
        <Grid item sm={12} lg={4}>
          <TextInput source="streetAddress" label="Street Address" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={4}>
          <TextInput source="city" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={4}>
          <TextInput source="zip" />
        </Grid>
        <Grid item sm={12} md={6} lg={3} xl={2}>
          <AutocompleteInput
            source="country"
            size="small"
            choices={CountryEnum.slice(1)}
            sx={{
              "#state": { width: "100%" },
            }}
            emptyValue={""}
            validate={required()}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={3} xl={2}>
          <StateInput />
        </Grid>
        <Grid item md={12} lg={6} xl={8}>
          <PhoneInput source="phone" label="Phone" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={6}>
          <ReferenceInput
            source="type.id"
            reference="admin/maker/filters"
            filter={{ type: "type" }}
            validate={required()}
          >
            <SelectInput
              label="Type"
              optionText={(record) => {
                return record.name;
              }}
            />
          </ReferenceInput>
        </Grid>
        <Grid item sm={12} lg={6}>
          <ReferenceInput
            source="region.id"
            reference="admin/maker/filters"
            filter={{ type: "region" }}
            validate={required()}
          >
            <SelectInput
              label="Region"
              optionText={(record) => {
                return record.name;
              }}
            />
          </ReferenceInput>
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
)};
